(function () {
  const PLACEMENT_SELECTOR =
    'square-placement[id*="afterpay_on_site_messaging_payments_messaging"]';

  const TOTAL_LINE_ID = "hlbd-qty-total-line";

  function extractNumber(text) {
    const m = (text || "").match(/[\d,.]+/);
    if (!m) return null;
    const n = parseFloat(m[0].replace(/,/g, ""));
    return Number.isFinite(n) ? n : null;
  }

  function formatAUD(amountNumber) {
    try {
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(amountNumber);
    } catch (e) {
      return `$${amountNumber.toFixed(2)} AUD`;
    }
  }

  function getUnitPrice() {
    const priceRoot = document.querySelector(".price");
    if (!priceRoot) return null;

    const saleEl =
      priceRoot.querySelector(".price__sale .price-item--sale") ||
      priceRoot.querySelector(".price-item--sale");

    const regularEl =
      priceRoot.querySelector(".price__regular .price-item--regular") ||
      priceRoot.querySelector(".price-item--regular");

    const text =
      (saleEl && saleEl.textContent) ||
      (regularEl && regularEl.textContent) ||
      priceRoot.textContent;

    return extractNumber(text);
  }

  function getQty() {
    const qtyInput =
      document.querySelector('form[action*="/cart/add"] .quantity__input') ||
      document.querySelector(".quantity__input");

    if (!qtyInput) return 1;

    const q = parseInt(qtyInput.value, 10);
    return Number.isFinite(q) && q > 0 ? q : 1;
  }

  function getVariantId() {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return "";
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? String(idInput.value || "") : "";
  }

  function findAfterpayPlacements() {
    return Array.from(document.querySelectorAll(PLACEMENT_SELECTOR));
  }

  function rerender(el) {
    const clone = el.cloneNode(true);
    el.parentNode.replaceChild(clone, el);
  }

  function ensureTotalLine() {
    const qtyWrap =
      document.querySelector("form[action*='/cart/add'] quantity-input") ||
      document.querySelector("quantity-input") ||
      document.querySelector("form[action*='/cart/add'] .quantity") ||
      document.querySelector(".quantity");

    if (!qtyWrap) return null;

    let line = document.getElementById(TOTAL_LINE_ID);
    if (line) return line;

    line = document.createElement("div");
    line.id = TOTAL_LINE_ID;

    // Simple styling
    line.style.marginTop = "8px";
    line.style.fontSize = "13px";
    line.style.opacity = "0.8";
    line.style.lineHeight = "1.2";
    line.style.display = "none"; // start hidden

    qtyWrap.insertAdjacentElement("afterend", line);
    return line;
  }

  let lastKey = "";

  function refresh() {
    try {
      const unit = getUnitPrice();
      if (unit == null) return;

      const qty = getQty();
      const totalNum = unit * qty;
      const totalStr = totalNum.toFixed(2);
      const variantId = getVariantId();

      const key = `${variantId}|${qty}|${totalStr}`;
      if (key === lastKey) return;
      lastKey = key;

      // Update Afterpay amount (uses total)
      const placements = findAfterpayPlacements();
      placements.forEach((el) => {
        el.setAttribute("data-amount", totalStr);
        rerender(el);
      });

      // Update the “Total: …” line (ONLY when qty > 1)
      const line = ensureTotalLine();
      if (line) {
        if (qty > 1) {
          line.textContent = `Total: ${formatAUD(totalNum)}`;
          line.style.display = "";
        } else {
          line.textContent = "";
          line.style.display = "none";
        }
      }
    } catch (e) {
      // never break the page
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    refresh();

    // + / - buttons
    document.addEventListener("click", function (e) {
      const btn =
        e.target &&
        e.target.closest &&
        e.target.closest('button[name="plus"], button[name="minus"]');
      if (btn) setTimeout(refresh, 30);
    });

    // typing in qty box
    document.addEventListener("input", function (e) {
      if (
        e.target &&
        e.target.classList &&
        e.target.classList.contains("quantity__input")
      ) {
        setTimeout(refresh, 30);
      }
    });

    // price changes (variant swaps)
    const priceRoot = document.querySelector(".price");
    if (priceRoot) {
      const obs = new MutationObserver(() => setTimeout(refresh, 30));
      obs.observe(priceRoot, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    // backup (variant id / dynamic rerenders)
    setInterval(refresh, 300);
  });
})();
